var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3048 14.2649H2.69527C2.31792 14.2645 1.95614 14.1145 1.68932 13.8478C1.4225 13.5812 1.27243 13.2197 1.27203 12.8426V5.67846C1.27243 5.3014 1.4225 4.9399 1.68932 4.67327C1.95614 4.40664 2.31792 4.25665 2.69527 4.25622H14.3048C14.6821 4.25665 15.0439 4.40664 15.3107 4.67327C15.5776 4.9399 15.7276 5.3014 15.728 5.67846V12.8426C15.7276 13.2197 15.5776 13.5812 15.3107 13.8478C15.0439 14.1145 14.6821 14.2645 14.3048 14.2649ZM2.69527 4.79978C2.46214 4.80003 2.23863 4.89269 2.07379 5.05743C1.90895 5.22216 1.81625 5.44551 1.81603 5.67846V12.8426C1.81625 13.0756 1.90895 13.2989 2.07379 13.4637C2.23863 13.6284 2.46214 13.7211 2.69527 13.7213H14.3048C14.5379 13.7211 14.7614 13.6284 14.9263 13.4637C15.0911 13.2989 15.1838 13.0756 15.184 12.8426V5.67846C15.1838 5.44551 15.0911 5.22216 14.9263 5.05743C14.7614 4.89269 14.5379 4.80003 14.3048 4.79978H2.69527Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49997 10.86C8.43367 10.86 8.36964 10.8359 8.31991 10.792L1.76471 5.01014L2.1247 4.60247L8.49997 10.2262L14.8755 4.60315L15.2355 5.01082L8.68031 10.7927C8.63045 10.8364 8.5663 10.8604 8.49997 10.86Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61682 13.4114L6.02054 8.39784L6.42962 8.75659L2.02591 13.7701L1.61682 13.4114Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5842 8.75131L10.9933 8.39256L15.3971 13.4062L14.988 13.765L10.5842 8.75131Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/Emailicon.3c06f3fea18fc70da5b22c0e0b57b8d7.svg";
export { ForwardRef as ReactComponent };